/* eslint-disable max-lines-per-function */
import {PageManager} from '@mvps-genesis/bootstrap';
import './BLOG.scss';

export default class BLOG extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {

		$('.leave-comment').on('click', function (e) {
			e.preventDefault();
			$('.comment-form').slideToggle();
		});

	}

}
